import { call, put } from 'redux-saga/effects';
import * as actions from './chart.actions';
import * as chartResourceService from '../../../resource/chart/chart.saga-service';
import { normalizeNodes } from '../../chart/chart.saga-services';

export function* clearChart() {
  yield put(actions.clearChart());
}

export function* setupChart(chartType: string) {
  const { nodes } = (yield call(
    chartResourceService.getChart,
    chartType,
  )) as chartResourceService.IChartWithNodesResult;

  const list = normalizeNodes(nodes);
  if (!list.length) {
    yield put(actions.clearChart());
    return;
  }

  yield put(actions.storeChart(list.map((node) => String(node.id))));
}

export function* clearChartPageStorage() {
  yield put(actions.clearChart());
}
